import React from "react";
import Helmet from "react-helmet";

const SEO = ({ title, description }) => (
  <Helmet
    htmlAttributes={{ lang: "ja-jp" }}
    title={title}
    description={description}
  >
    <meta name="description" content={description} />
    <meta
      property="og:image"
      content="https://objective-bose-517249.netlify.app/static/top-8286105f522aa76c6a11f293e82c1478.png"
    />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta
      name="twitter:image"
      content="https://objective-bose-517249.netlify.app/static/top-8286105f522aa76c6a11f293e82c1478.png"
    />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
  </Helmet>
);

export default SEO;
